import { hbs } from 'ember-cli-htmlbars';
export default hbs("<span {{did-insert this.didInsert}}></span>\n{{duration @crawlingSession.startedAt this.currentTime \"seconds\" false true}}")